@if (shown) {
    @if (type === 'line-note') {
        <div class="search-progressbar animated line-note"
             [style.opacity]="opacity"
             [style.margin-top]="marginTop"
             [style.margin-bottom]="marginBottom"
             [style.transition]="opacityTransition">
            <span class="text">{{ currentText }}</span>
            <div class="bar-wrap">
      <span class="bar"
            [style.width.%]="viewProgress"
            [style.transitionDuration]="transitionD"></span>
            </div>
        </div>

        <ng-content></ng-content>
    }

    @if (type === 'line') {
        <div class="search-progressbar animated line-note line-only"
             [class.hotels-search]="isDesktopHotelsSearch">
            <div class="bar-wrap">
        <span class="bar"
              [style.width.%]="viewProgress"
              [style.transitionDuration]="transitionD"></span>
            </div>
        </div>
    }
    @if (type === 'button' && !isFooterVisible) {
        <div class="search-progressbar animated button">
            <span class="text">{{ searchProgressLabel }}</span>
            <span class="bar"
                  [style.width.%]="viewProgress"
                  [style.transitionDuration]="transitionD"></span>
        </div>
    }
}

